import React, {useMemo, useState} from "react";
import {Button, Spinner, Table} from "react-bootstrap";
import {ArrowRightSquareFill, BoxArrowInRight, ChevronDown, ChevronUp, Eye, EyeFill, EyeSlashFill, Map, MapFill, Pen, PenFill, SortAlphaDown, SortAlphaUp} from "react-bootstrap-icons";
import FilterInput from "./FilterInput";
import useDictionaryFilter from "../hooks/useDictionaryFilter";
import {SHOW_UNFINISHED_STUFF} from "../Const";
import * as Const from "../Const";



function ParcelRow( {mqttClient, parcel, onParcelClicked, isHidden, isForCurrentMachine, isSelectedByCurrentMachine,
                        onParcelVisibilityToggleClicked, editedParcel, onParcelEditClicked, rowClass = ""} ) {

    const [isButtonDisabled, setButtonDisabled] = useState(false);

    const displayName = decodeURIComponent(parcel['parcel_name']);
    const fieldName = parcel['field_name'];
    return(
        <tr className={rowClass}>
            {isSelectedByCurrentMachine
                ? <td className={"align-content-center p-0 m-0"}>
                    {/*<div className={"p-0 m-0"} style={{rotate: "-90deg"}}>Selected</div>*/}
                    <div className={"h5 p-2"} aria-label={"Currently Selected Parcel"}><ArrowRightSquareFill /></div>
                </td>
                : <td />
            }
            <td className={"align-content-center py-1"}>
                <Button className={"btn-sm btn-light"} onClick={() => onParcelVisibilityToggleClicked(fieldName)}>{isHidden ? <EyeSlashFill/> : <Eye/>}</Button>
                {SHOW_UNFINISHED_STUFF && parcel['trajectory'] === undefined && (editedParcel === null || parcel === editedParcel)
                    ? <Button className={"btn-sm btn-light"} onClick={() => onParcelEditClicked(parcel)}><Pen/></Button>
                    : null
                }
            </td>
            <td className={"overflow-x-hidden"} onClick={() => onParcelClicked(parcel)}>
                {/*{isForCurrentMachine && isSelectedByCurrentMachine ? <div><i>Selected Parcel</i></div> : null}*/}
                {/*<span className={"text-truncate"} style={{color:"#ccc"}}>{parcel['field_name']}</span><br />*/}
                <div className={""} title={displayName}>{displayName}</div>
                <div className={""} style={{color: "#777"}}> ({parcel['machine']})</div>
                {/*{SHOW_UNFINISHED_STUFF ? <div className={""} style={{color: "#ccc"}}> ({fieldName})</div> : null}*/}
                {/*{SHOW_UNFINISHED_STUFF && parcel['trajectory'] ? <div className={"text-truncate"} style={{color: "#f00"}}>Trajectory</div> : null}*/}
            </td>
            <td className={"align-middle"}>
                {isForCurrentMachine
                    ? <div>
                        {isSelectedByCurrentMachine
                            ? null //<div className={"btn btn-sm disabled"}><CheckSquareFill /></div>
                            : <Button className={"btn-sm btn-light d-flex align-items-center" + (isButtonDisabled ? " disabled" : "")} aria-label={"Select Parcel"}
                                      onClick={() => {
                                setButtonDisabled(true);
                                setTimeout(() => {setButtonDisabled(false)}, 5000);
                                let topic = parcel['machine'] + "/" + Const.MQTT_PUBLISH_CMD_SELECT_PARCEL;
                                console.log(topic, parcel['list_index']);
                                mqttClient?.publish(topic, parcel['list_index'], {qos: 0, retain: false});
                            }}><BoxArrowInRight className={"h6 my-1"} /></Button>
                        }
                    </div>
                    : null
                }
            </td>
        </tr>
    );
}


function OverviewParcelList( {mqttClient, parcels, isParcelsLoading, parcelFilter, machineFilter, selectedMachineName, selectedFieldName,
                                 onParcelClicked, hiddenParcels, onParcelVisibilityClicked, onParcelFilterChanged, workConfigurations,
                                 editedParcel, onParcelEditClicked} ) {

    const [isTableOpen, setTableOpen] = useState(true);

    const [sortDirection, setSortDirection] = useState(1);
    const [showOnlyActiveMachine, setShowOnlyActiveMachine] = useState(false);
    const [showOnlyEditable, setShowOnlyEditable] = useState(false);
    const [showOnlyVisible, setShowOnlyVisible] = useState(false);

    const machineParcels = useMemo(() => {
        // if (!parcels) {
        //     return [];
        // }
        return Object.values(parcels).flat();
    }, [parcels]);
    
    const activeMachineFilter = useMemo(() => {
        return (selectedMachineName ?? machineFilter).toLowerCase();
    }, [machineFilter, selectedMachineName]);
    

    const filteredParcels = useDictionaryFilter(machineParcels, 'parcel_name', parcelFilter);
    const machineFilteredParcels = useDictionaryFilter(filteredParcels, 'machine', selectedMachineName ?? machineFilter);
    // const machineFilteredParcels = filteredParcels;

    const displayedParcels = showOnlyActiveMachine ? machineFilteredParcels : filteredParcels;

    const sortedParcels = useMemo(() => {
        const sortBy = 'parcel_name';
        // const filter = (selectedMachineName ?? machineFilter).toLowerCase();
        // console.log("sorting parcels, machine filter: ", activeMachineFilter);
        return (displayedParcels && displayedParcels.length > 0)
            ? displayedParcels.sort((a, b) => {
                return sortDirection * a[sortBy].localeCompare(b[sortBy]);
            })
            : [];
    }, [displayedParcels, sortDirection]);

    
    const listedParcels = useMemo(() => {
        let result = sortedParcels;
        if (showOnlyEditable) {
            result = result.filter(parcel => parcel['trajectory'] === undefined)
        }
        if (showOnlyVisible) {
            result = result.filter(parcel => !hiddenParcels.has(parcel['field_name']));
        }
        return result;
    }, [hiddenParcels, showOnlyEditable, showOnlyVisible, sortedParcels]);
    
    // const selectedParcels = useMemo(() => {
    //     return sortedParcels.filter(p => p['field_name'] === selectedFieldName);
    // }, [selectedFieldName, sortedParcels])

    return (
        <div className={"card shadow-lg"}>
            <div className={"card-header"}>
                <Button className={"btn-light shadow-none"} onClick={() => setTableOpen(!isTableOpen)}>
                    {isTableOpen ? <><ChevronDown /> Parcels</> : <><ChevronUp /> Parcels</>}
                </Button>
                {isTableOpen
                    ?
                    <div className={"w-100"}>
                        <Button className={"btn-light shadow-none"} onClick={() => setShowOnlyActiveMachine(!showOnlyActiveMachine)}>
                            {showOnlyActiveMachine ? <MapFill /> : <Map />} Current&nbsp;Machine
                        </Button>
                        <Button className={"btn-light shadow-none"} onClick={() => setSortDirection(-sortDirection)}>
                            <div> {sortDirection > 0 ? <SortAlphaDown /> : <SortAlphaUp />} Sort</div>
                        </Button>
                        {SHOW_UNFINISHED_STUFF ?
                            <Button className={"btn-light shadow-none"} onClick={() => setShowOnlyEditable(!showOnlyEditable)}>
                                {showOnlyEditable ? <PenFill /> : <Pen />} Only&nbsp;Editable
                            </Button>
                            : null
                        }
                        <Button className={"btn-light shadow-none"} onClick={() => setShowOnlyVisible(!showOnlyVisible)}>
                            {showOnlyVisible ? <EyeFill /> : <Eye />} Only&nbsp;Visible
                        </Button>
                        <FilterInput filter={parcelFilter} onFilterChanged={(filter) => onParcelFilterChanged(filter)} />
                    </div>
                    : null
                }
            </div>

            {isTableOpen && isParcelsLoading
                ? <div className={"d-flex justify-content-center mt-3 mb-0"}><Spinner /></div>
                : null
            }

            {isTableOpen && listedParcels
                ? <div className={"card-body"} style={{maxHeight: "100%", overflowY: "auto", overflowX: "hidden"}}>
                    <Table className={"table-sm m-0"}>
                        <tbody>
                        { listedParcels.map(p => {
                            const name = p['field_name'];
                            const isForCurrentMachine = activeMachineFilter && p['machine'].includes(activeMachineFilter);
                            const isSelectedByCurrentMachine = isForCurrentMachine && p['field_name'] === workConfigurations[selectedMachineName];
                            const rowClass = name === selectedFieldName
                                ? "table-primary"
                                : isForCurrentMachine
                                    ? "table-success"
                                    : "";
                            const key = p['machine'] + p['field_name'];
                            return <ParcelRow key={key} mqttClient={mqttClient} parcel={p} isHidden={hiddenParcels.has(name)}
                                              isForCurrentMachine={isForCurrentMachine} isSelectedByCurrentMachine={isSelectedByCurrentMachine}
                                              onParcelVisibilityToggleClicked={onParcelVisibilityClicked} onParcelClicked={onParcelClicked}
                                              editedParcel={editedParcel} onParcelEditClicked={onParcelEditClicked}
                                              rowClass={rowClass}/>
                        })
                        }
                        </tbody>
                    </Table>
                </div>
                : null
            }
        </div>
    )
}



export default OverviewParcelList;
